{
  "labels": {
    "paste": "चिपकाएँ",
    "pasteAsPlaintext": "सादे पाठ के रूप में चिपकाएं",
    "pasteCharts": "चार्ट चिपकाएँ",
    "selectAll": "सभी चुनें",
    "multiSelect": "आकार को चयन में जोड़ें",
    "moveCanvas": "कैनवास को स्थानांतरित करें",
    "cut": "काटें",
    "copy": "प्रतिलिपि",
    "copyAsPng": "क्लिपबोर्ड पर कॉपी करें ,पीएनजी के रूप में",
    "copyAsSvg": "क्लिपबोर्ड पर कॉपी करें,एसवीजी के रूप में",
    "copyText": "लेखन के रूप में पटल पर कॉपी करें",
    "copySource": "स्त्रोत को प्रति-फलक पे प्रतिलिपित करे.",
    "convertToCode": "सांकेतिक लिपि में परिवर्तित करे",
    "bringForward": "सामने लाएं",
    "sendToBack": "पीछे भेजें",
    "bringToFront": "सामने लाएँ",
    "sendBackward": "पीचे भीजे",
    "delete": "मिटाए",
    "copyStyles": "कॉपी स्टाइल",
    "pasteStyles": "स्टाइल पेस्ट करें",
    "stroke": "रेखा",
    "background": "पृष्ठभूमि",
    "fill": "भरें",
    "strokeWidth": "रेखा की चौड़ाई",
    "strokeStyle": "स्ट्रोक का आकार",
    "strokeStyle_solid": "ठोस",
    "strokeStyle_dashed": "डैश",
    "strokeStyle_dotted": "बिंदीदार",
    "sloppiness": "बेढ़ंगापन",
    "opacity": "अपारदर्शिता",
    "textAlign": "टेक्स्ट संरेखन",
    "edges": "किनारा",
    "sharp": "नुकीला",
    "round": "गोल",
    "arrowheads": "तीर शीर्ष",
    "arrowhead_none": "कोई भी नहीं",
    "arrowhead_arrow": "तीर",
    "arrowhead_bar": "बार",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "त्रिकोण",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "फ़ॉन्ट का आकार",
    "fontFamily": "फ़ॉन्ट का परिवार",
    "addWatermark": "ऐड \"मेड विथ एक्सकैलिडराव\"",
    "handDrawn": "हाथ से बनाया हुआ",
    "normal": "साधारण",
    "code": "कोड",
    "small": "छोटा",
    "medium": "मध्यम",
    "large": "बड़ा",
    "veryLarge": "बहुत बड़ा",
    "solid": "दृढ़",
    "hachure": "हैशूर",
    "zigzag": "तेढ़ी मेढ़ी",
    "crossHatch": "क्रॉस हैच",
    "thin": "पतला",
    "bold": "मोटा",
    "left": "बाएं",
    "center": "मध्य",
    "right": "दाएँ",
    "extraBold": "बहुत मोटा",
    "architect": "वास्तुकार",
    "artist": "कलाकार",
    "cartoonist": "व्यंग्य चित्रकार",
    "fileTitle": "फ़ाइल का नाम",
    "colorPicker": "रंग चयन",
    "canvasColors": "कॅनवास पर प्रयोगित",
    "canvasBackground": "कैनवास बैकग्राउंड",
    "drawingCanvas": "कैनवास बना रहे हैं",
    "layers": "परतें",
    "actions": "कार्रवाई",
    "language": "भाषा",
    "liveCollaboration": "जीवंत सहयोग...",
    "duplicateSelection": "डुप्लिकेट",
    "untitled": "अशीर्षित",
    "name": "नाम",
    "yourName": "आपका नाम",
    "madeWithExcalidraw": "मेड विथ एक्सकैलिडराव",
    "group": "समूह चयन",
    "ungroup": "समूह चयन असमूहीकृत करें",
    "collaborators": "सहयोगी",
    "showGrid": "ग्रिड दिखाएं",
    "addToLibrary": "लाइब्रेरी से जोड़ें",
    "removeFromLibrary": "लाइब्रेरी से निकालें",
    "libraryLoadingMessage": "लाइब्रेरी खुल रही है",
    "libraries": "लाइब्रेरी ब्राउज़ करें",
    "loadingScene": "दृश्य खुल रहा है",
    "align": "संरेखित करें",
    "alignTop": "ऊपर संरेखित करें",
    "alignBottom": "नीचे संरेखित करें",
    "alignLeft": "बायें संरेखित करें",
    "alignRight": "दायें संरेखित करें",
    "centerVertically": "लंबवत केन्द्रित",
    "centerHorizontally": "क्षैतिज केन्द्रित",
    "distributeHorizontally": "क्षैतिज रूप से वितरित करें",
    "distributeVertically": "खड़ी रूप से वितरित करें",
    "flipHorizontal": "दायें बायें पलटे",
    "flipVertical": "ऊपर नीचे पलटे",
    "viewMode": "अलग अलग देखें",
    "share": "शेयर करें",
    "showStroke": "",
    "showBackground": "पृष्ठभूमि रंग वरक़ दिखाये",
    "toggleTheme": "",
    "personalLib": "वैयक्तिक समूहकोष",
    "excalidrawLib": "एक्सकेलीड्रॉ समूहकोष",
    "decreaseFontSize": "आकार घटाइऐ",
    "increaseFontSize": "फ़ॉन्ट आकार बढ़ाएँ",
    "unbindText": "लिपि को बंधमुक्त करें",
    "bindText": "लेखन को कोश से जोड़े",
    "createContainerFromText": "मूलपाठ कंटेनर में मोड के दिखाए",
    "link": {
      "edit": "कड़ी संपादित करे",
      "editEmbed": "",
      "create": "",
      "createEmbed": "",
      "label": "",
      "labelEmbed": "",
      "empty": ""
    },
    "lineEditor": {
      "edit": "रेखा संपादित करे",
      "exit": "रेखा संपादक के बाहर"
    },
    "elementLock": {
      "lock": "ताले में रखें",
      "unlock": "ताले से बाहर",
      "lockAll": "सब ताले के अंदर रखे",
      "unlockAll": "सब ताले के बाहर निकाले"
    },
    "statusPublished": "प्रकाशित",
    "sidebarLock": "साइडबार खुला रखे.",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "चित्रफलक से रंग चुने",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "अभी तक कोई आइटम जोडा नहीं गया.",
    "hint_emptyLibrary": "यहाँ जोड़ने के लिए पटल से एक वस्तु चुने, अथवा जन कोष से एक संग्रह नीचे स्थापित करें.",
    "hint_emptyPrivateLibrary": "यहाँ जोड़ने के लिए पटल से एक वस्तु चुने."
  },
  "buttons": {
    "clearReset": "कैनवास रीसेट करें",
    "exportJSON": "",
    "exportImage": "प्रतिमा निर्यात करे...",
    "export": "यंहा सुरक्षित करे...",
    "copyToClipboard": "क्लिपबोर्ड पर प्रतिलिपि बनाएँ",
    "save": "",
    "saveAs": "सेव करे इस तरह",
    "load": "खोलें",
    "getShareableLink": "साझा करने योग्य लिंक प्राप्त करें",
    "close": "बंद करें",
    "selectLanguage": "भाषा चुनें",
    "scrollBackToContent": "सामग्री पर वापस स्क्रॉल करें",
    "zoomIn": "बड़ा करें",
    "zoomOut": "छोटा करें",
    "resetZoom": "ज़ूम रीसेट करें",
    "menu": "मेन्यू",
    "done": "समाप्त",
    "edit": "संशोधन करें",
    "undo": "पूर्ववत् करें",
    "redo": "फिर से करें",
    "resetLibrary": "",
    "createNewRoom": "एक नया कमरा बनाएं",
    "fullScreen": "पूरी स्क्रीन",
    "darkMode": "डार्क मोड",
    "lightMode": "लाइट मोड",
    "zenMode": "ज़ेन मोड",
    "objectsSnapMode": "वस्तुओं से पकड़े",
    "exitZenMode": "जेन मोड से बाहर निकलें",
    "cancel": "",
    "clear": "साफ़ करे",
    "remove": "हटाएं",
    "embed": "",
    "publishLibrary": "प्रकाशित करें",
    "submit": "प्रस्तुत करे",
    "confirm": "पुष्टि करें",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "इससे पूरा कैनवास साफ हो जाएगा। क्या आपको यकीन है?",
    "couldNotCreateShareableLink": "साझा करने योग्य लिंक नहीं बनाया जा सका।",
    "couldNotCreateShareableLinkTooBig": "लिंक शेयर नहीं कर सकता: दृश्य बहुत बड़ा",
    "couldNotLoadInvalidFile": "अमान्य फ़ाइल लोड नहीं की जा सकी",
    "importBackendFailed": "बैकएंड से आयात करना विफल रहा।",
    "cannotExportEmptyCanvas": "खाली कैनवास निर्यात नहीं कर सकता।",
    "couldNotCopyToClipboard": "क्लिपबोर्ड पर कॉपी नहीं किया जा सका",
    "decryptFailed": "डेटा को डिक्रिप्ट नहीं किया जा सका।",
    "uploadedSecurly": "अपलोड को एंड-टू-एंड एन्क्रिप्शन के साथ सुरक्षित किया गया है, जिसका मतलब है कि एक्सक्लूसिव सर्वर और थर्ड पार्टी कंटेंट नहीं पढ़ सकते हैं।",
    "loadSceneOverridePrompt": "लोड हो रहा है बाहरी ड्राइंग आपके मौजूदा सामग्री को बदल देगा। क्या आप जारी रखना चाहते हैं?",
    "collabStopOverridePrompt": "चालू सत्र समाप्ति से आपका संग्रहित पूर्व स्थानीय अधिलेखन नष्ट होकर पुनः अधिलेखित होगा, क्या आपको यक़ीन हैं? ( यदी आपको पूर्व स्थापित अधिलेखन सुरक्षित चाहिये तो बस ब्राउज़र टैब बंद करे)",
    "errorAddingToLibrary": "संग्रह में जोडा न जा सका",
    "errorRemovingFromLibrary": "संग्रह से हटाया नहीं जा सका",
    "confirmAddLibrary": "लाइब्रेरी जोड़ें पुष्‍टि करें आकार संख्या",
    "imageDoesNotContainScene": "ऐसा लगता है कि इस छवि में कोई दृश्य डेटा नहीं है। क्या आपने निर्यात के दौरान दृश्य एम्बेडिंग अनुमतित की है?",
    "cannotRestoreFromImage": "छवि फ़ाइल बहाल दृश्य नहीं है",
    "invalidSceneUrl": "दिये गये युआरेल से दृश्य आयात नहीं किया जा सका. यह या तो अनुचित है, या इसमें उचित Excalidraw JSON डेटा नहीं है।",
    "resetLibrary": "यह पूरा संग्रह रिक्त करेगा. क्या आपको यक़ीन हैं?",
    "removeItemsFromsLibrary": "{{count}} वस्तु(यें) संग्रह से हटायें?",
    "invalidEncryptionKey": "कूटलेखन कुंजी 22 अक्षरों की होनी चाहिये, इसलिये जीवंत सहयोग अक्षम हैं",
    "collabOfflineWarning": "कोई इंटरनेट कनेक्शन उपलब्ध नहीं है।\nआपके बदलाव सहेजे नहीं जाएंगे!"
  },
  "errors": {
    "unsupportedFileType": "असमर्थित फाइल प्रकार",
    "imageInsertError": "छवि सम्मिलित नहीं की जा सकी. पुनः प्रयत्न करे...",
    "fileTooBig": "फ़ाइल ज़रूरत से ज़्यादा बड़ी हैं. अधिकतम अनुमित परिमाण {{maxSize}} हैं",
    "svgImageInsertError": "एसवीजी छवि सम्मिलित नहीं कर सके, एसवीजी रचना अनुचित हैं",
    "failedToFetchImage": "",
    "invalidSVGString": "अनुचित SVG",
    "cannotResolveCollabServer": "कॉलेब सर्वर से कनेक्शन नहीं हो पा रहा. कृपया पृष्ठ को पुनः लाने का प्रयास करे.",
    "importLibraryError": "संग्रह प्रतिष्ठापित नहीं किया जा सका",
    "collabSaveFailed": "किसी कारण वश अंदरूनी डेटाबेस में सहेजा नहीं जा सका। यदि समस्या बनी रहती है, तो किये काम को खोने न देने के लिये अपनी फ़ाइल को स्थानीय रूप से सहेजे।",
    "collabSaveFailed_sizeExceeded": "लगता है कि पृष्ठ तल काफ़ी बड़ा है, इस्कारण अंदरूनी डेटाबेस में सहेजा नहीं जा सका। किये काम को खोने न देने के लिये अपनी फ़ाइल को स्थानीय रूप से सहेजे।",
    "imageToolNotSupported": "प्रतिमायें अक्षम की गयी हैं",
    "brave_measure_text_error": {
      "line1": "लगता है कि आप Brave ब्राउज़र का उपयोग कर रहे और साथ में <bold>आक्रामक उँगलियो के छाप </bold> का चयन किया हुवा है",
      "line2": "यह आपके चित्रों के <bold>पाठ तत्वों</bold>को खंडित कर सकता हैं",
      "line3": "हमें आपसे ठोस आग्रह है की आप सेट्टिंग में इस विकल्प का चयन ना करे.<link> इस अनुक्रम </link> का पालन करके इसका पता लगा सकते हैं",
      "line4": "यदि इस सेटिंग्स को अक्षम करने पर भी पृष्ठ ठीक नहीं दिखता हो तो, हमारे GitHub पर एक <issueLink>मुद्दा प्रस्तुत</issueLink> करे, या हमें <discordLink>डिस्कोर्ड</discordLink> पर लिखित सम्पर्क करें"
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "आयफ़्रेम तत्व समूहकोष में जोडा नहीं जा सका.",
      "image": ""
    },
    "asyncPasteFailedOnRead": "चिपकाया नहीं जा सका (सिस्टम क्लिपबोर्ड से पढ़ा नहीं जा सका).",
    "asyncPasteFailedOnParse": "चिपकाया नहीं जा सका.",
    "copyToSystemClipboardFailed": "क्लिपबोर्ड पर प्रतिलिपि नहीं बनाई जा सकी."
  },
  "toolBar": {
    "selection": "चयन",
    "image": "छवि सम्मिलित करें",
    "rectangle": "आयात",
    "diamond": "तिर्यग्वर्ग",
    "ellipse": "दीर्घवृत्त",
    "arrow": "तीर",
    "line": "रेखा",
    "freedraw": "चित्रांतित करे",
    "text": "पाठ",
    "library": "लाइब्रेरी",
    "lock": "ड्राइंग के बाद चयनित टूल को सक्रिय रखें",
    "penMode": "पेन का मोड - स्पर्श टाले",
    "link": "",
    "eraser": "रबड़",
    "frame": "",
    "magicframe": "तारिक ढाँचें को सांकेतिक लिपि में",
    "embeddable": "",
    "laser": "लेसर टॉर्च",
    "hand": "हाथ ( खिसकाने का औज़ार)",
    "extraTools": "",
    "mermaidToExcalidraw": "मर्मेड से एक्सकाली में",
    "magicSettings": "कृतिम बुद्धिमत्ता सेटिंग्स"
  },
  "headings": {
    "canvasActions": "कैनवास क्रिया",
    "selectedShapeActions": "चयनित आकृति क्रियाएं",
    "shapes": "आकृतियाँ"
  },
  "hints": {
    "canvasPanning": "कैनवास को सरकाने के लिए, ड्रैग करते समय माउस व्हील को पकड़े रखे या स्पेसबार को दबाए रखे, अथवा हाथ वाले औज़ार का उपयोग करें",
    "linearElement": "कई बिंदुओं को शुरू करने के लिए क्लिक करें, सिंगल लाइन के लिए खींचें",
    "freeDraw": "क्लिक करें और खींचें। समाप्त करने के लिए, छोड़ो",
    "text": "आप चयन टूल से कहीं भी डबल-क्लिक करके टेक्स्ट जोड़ सकते हैं",
    "embeddable": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "अंतिम बिंदु पर क्लिक करें या समाप्त होने के लिए एस्केप या एंटर दबाएं",
    "lockAngle": "आप घूर्णन करते समय SHIFT पकड़कर कोणों को मोड़ सकते हैं",
    "resize": "आकार बदलते समय आप SHIFT को पकड़ कर अनुपात में कमी कर सकते हैं,\nकेंद्र से आकार बदलने के लिए ALT दबाए रखें",
    "resizeImage": "",
    "rotate": "आप घूर्णन करते समय SHIFT पकड़कर कोणों को विवश कर सकते हैं",
    "lineEditor_info": "बिंदुओं को सम्पादित करने के लिए CtrlOrCmd को दबायें रखते हुये डबल क्लिक करे, अथवा CtrlOrCmd + Enter साथ दबाये",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "placeImage": "",
    "publishLibrary": "",
    "bindTextToElement": "",
    "deepBoxSelect": "",
    "eraserRevert": "मिटाने के लिए चुने हुए चीजों को ना चुनने के लिए Alt साथ में दबाए",
    "firefox_clipboard_write": "\"dom.events.asyncClipboard.clipboardItem\" फ़्लैग को \"true\" पर सेट करके इस सुविधा को संभवतः सक्षम किया जा सकता है। Firefox में ब्राउज़र फ़्लैग बदलने के लिए, \"about:config\" पृष्ठ पर जाएँ।",
    "disableSnapping": "स्नैपिंग को निष्क्रिय करने के लिए CtrlOrCmd दबाए रखें"
  },
  "canvasError": {
    "cannotShowPreview": "पूर्वावलोकन नहीं दिखा सकते हैं",
    "canvasTooBig": "कैनवास बहुत बड़ा",
    "canvasTooBigTip": "कैनवास बहुत बड़ा टिप"
  },
  "errorSplash": {
    "headingMain": "एक त्रुटि का सामना करना पड़ा। प्रयत्न <button>इस पृष्ठ को पुनः लोड करें</button>",
    "clearCanvasMessage": "यदि पुनः लोड करना काम नहीं करता है, तो प्रयास करें <button>कैनवास साफ करना।</button>",
    "clearCanvasCaveat": " इससे काम का नुकसान होगा ",
    "trackedToSentry": "पहचानकर्ता के साथ त्रुटि {{eventId}} हमारे सिस्टम पर नज़र रखी गई थी।",
    "openIssueMessage": "हम बहुत सतर्क थे कि त्रुटि पर आपकी दृश्य जानकारी शामिल न करें। यदि आपका दृश्य निजी नहीं है, तो कृपया हमारे बारे में विचार करें <button>बग ट्रैकर</button> कृपया GitHub मुद्दे को कॉपी और पेस्ट करके नीचे दी गई जानकारी शामिल करें।",
    "sceneContent": "दृश्य सामग्री:"
  },
  "roomDialog": {
    "desc_intro": "आप अपने वर्तमान दृश्य के लोगों को अपने साथ सहयोग करने के लिए आमंत्रित कर सकते हैं।",
    "desc_privacy": "चिंता न करें, सत्र अंत-से-अंत एन्क्रिप्शन का उपयोग करता है, इसलिए आप जो भी ड्रा करेंगे वह निजी रहेगा। यहां तक कि हमारा सर्वर भी नहीं देख पाएगा कि आप क्या कर रहे हैं।",
    "button_startSession": "सत्र प्रारंभ करें",
    "button_stopSession": "सत्र रुकें",
    "desc_inProgressIntro": "लाइव सहयोग सत्र अब जारी है।",
    "desc_shareLink": "इस लिंक को आप जिस किसी के साथ भी सहयोग करना चाहते हैं, उसके साथ साझा करें",
    "desc_exitSession": "सत्र रोकना आपको रूम से बाहर कर देगा, लेकिन आप स्थानीय स्तर पर दृश्य के साथ काम करना जारी रख पाएंगे। ध्यान दें कि यह अन्य लोगों को प्रभावित नहीं करेगा, और वे अभी भी अपने संस्करण पर सहयोग करने में सक्षम होंगे।",
    "shareTitle": ""
  },
  "errorDialog": {
    "title": "गलती"
  },
  "exportDialog": {
    "disk_title": "",
    "disk_details": "",
    "disk_button": "",
    "link_title": "",
    "link_details": "",
    "link_button": "",
    "excalidrawplus_description": "",
    "excalidrawplus_button": "",
    "excalidrawplus_exportError": ""
  },
  "helpDialog": {
    "blog": "हमारा ब्लॉग पढे",
    "click": "क्लिक करें",
    "deepSelect": "",
    "deepBoxSelect": "",
    "curvedArrow": "वक्र तीर",
    "curvedLine": "वक्र रेखा",
    "documentation": "",
    "doubleClick": "",
    "drag": "खींचें",
    "editor": "संपादक",
    "editLineArrowPoints": "रेखा/तीर बिंदु सम्पादित करे",
    "editText": "पाठ्य सम्पादित करे/ लेबल जोड़े",
    "github": "मुद्दा मिला? प्रस्तुत करें",
    "howto": "हमारे गाइड का पालन करें",
    "or": "या",
    "preventBinding": "तीर बंधन रोकें",
    "tools": "औज़ार",
    "shortcuts": "कीबोर्ड के शॉर्टकट्स",
    "textFinish": "",
    "textNewLine": "",
    "title": "मदद",
    "view": "दृश्य",
    "zoomToFit": "सभी तत्वों को फिट करने के लिए ज़ूम करें",
    "zoomToSelection": "चयन तक ज़ूम करे",
    "toggleElementLock": "ताले के अंदर/बाहर चुनाव",
    "movePageUpDown": "पृष्ठ ऊपर/नीचे करे",
    "movePageLeftRight": "पृष्ठ बायी/दायी तरफ करे"
  },
  "clearCanvasDialog": {
    "title": ""
  },
  "publishDialog": {
    "title": "",
    "itemName": "",
    "authorName": "",
    "githubUsername": "",
    "twitterUsername": "",
    "libraryName": "",
    "libraryDesc": "",
    "website": "",
    "placeholder": {
      "authorName": "",
      "libraryName": "",
      "libraryDesc": "",
      "githubHandle": "",
      "twitterHandle": "",
      "website": ""
    },
    "errors": {
      "required": "",
      "website": "मान्य URL प्रविष्ट करें"
    },
    "noteDescription": "संग्रह सम्मिलित करने हेतु प्रस्तुत करें <link>सार्वजनिक संग्रहालय</link>अन्य वक्तियों को उनके चित्रकारी में उपयोग के लिये",
    "noteGuidelines": "संग्रह को पहले स्वीकृति आवश्यक कृपया यह पढ़ें <link>दिशा-निर्देश</link>",
    "noteLicense": "जमा करके, आप सहमत हैं कि संग्रहण को <link>MIT लाइसेंस</link> के तहत प्रकाशित किया जाएगा, जिसका संक्षिप्त अर्थ है कि कोई भी बिना किसी प्रतिबंध के उनका उपयोग कर सकता है।",
    "noteItems": "",
    "atleastOneLibItem": "",
    "republishWarning": "टिप्पणी: कुछ चुने हुवे आइटम पहले ही प्रकाशित/प्रस्तुत किए जा चुके हैं। किसी प्रकाशित संग्रह को अद्यतन करते समय या पहले से प्रस्तुत आइटम को पुन्हा प्रस्तुत करते समय, आप बस उसे केवल अद्यतन करें ।"
  },
  "publishSuccessDialog": {
    "title": "",
    "content": "{{authorName}} धन्यवाद. आपका संग्रहण समीक्षा के लिए दर्ज हो चुका है. समीक्षा स्थिति <link>यहाँ</link>जान सकते हैं."
  },
  "confirmDialog": {
    "resetLibrary": "",
    "removeItemsFromLib": ""
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "आपके चित्र अंत-से-अंत एन्क्रिप्टेड हैं, इसलिए एक्सक्लूसिव्रॉव के सर्वर उन्हें कभी नहीं देखेंगे।",
    "link": ""
  },
  "stats": {
    "angle": "कोण",
    "element": "एलिमेंट",
    "elements": "एलिमेंट",
    "height": "ऊंचाई",
    "scene": "दृश्य",
    "selected": "चयनित",
    "storage": "संग्रह",
    "title": "बेवकूफ के लिए आँकड़े",
    "total": "कुल",
    "version": "संस्करण",
    "versionCopy": "काॅपी करने के लिए क्लिक करें",
    "versionNotAvailable": "संस्करण उपलब्ध नहीं है",
    "width": "चौड़ाई"
  },
  "toast": {
    "addedToLibrary": "",
    "copyStyles": "काॅपी कीए स्टाइल",
    "copyToClipboard": "क्लिपबोर्ड में कॉपी कीए",
    "copyToClipboardAsPng": "",
    "fileSaved": "",
    "fileSavedToFilename": "",
    "canvas": "",
    "selection": "",
    "pasteAsSingleElement": "एक अवयव के रूप में चिपकाने के लिए {{shortcut}} का उपयोग करें,\nया किसी मौजूदा पाठ संपादक में चिपकायें",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": ""
  },
  "colors": {
    "transparent": "",
    "black": "काला",
    "white": "सफ़ेद",
    "red": "लाल",
    "pink": "गुलाबी",
    "grape": "अंगूरी",
    "violet": "जामुनी",
    "gray": "गहरा",
    "blue": "नीला",
    "cyan": "आसमानी",
    "teal": "हरा-नीला",
    "green": "हरा",
    "yellow": "पीला",
    "orange": "नारंगी",
    "bronze": "कांस्य"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "आपका सर्व डेटा ब्राउज़र के भीतर स्थानिक जगह पे सुरक्षित किया गया.",
      "center_heading_plus": "बजाय आपको Excalidraw+ पर जाना है?",
      "menuHint": "निर्यात, पसंद, भाषायें, ..."
    },
    "defaults": {
      "menuHint": "निर्यात, पसंद, और भी...",
      "center_heading": "चित्रांकन। बनाया गया। सरल।",
      "toolbarHint": "एक औजार चुने और चित्रकारी प्रारंभ करे!",
      "helpHint": "शॉर्ट्कट और सहाय्य"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "अधिकांश उपयोगित रंग",
    "colors": "रंग",
    "shades": "छाया",
    "hexCode": "हेक्स कोड",
    "noShades": "इस रंग की कोई छाया उपलब्ध नहीं हैं"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "छवि स्वरूप में निर्यात करे",
        "button": "छवि स्वरूप निर्यात करे",
        "description": "दृष्य डेटा छवि स्वरूप में निर्यात करे, उस स्वरूप से आप उसे पुनः आयात कर सकते हो"
      },
      "saveToDisk": {
        "title": "डिस्क में सम्हाले",
        "button": "डिस्क में सम्हाले",
        "description": "दृष्य डेटा बाहरी फ़ाइल में निर्यात करे, जहाँसे आप उसे पुनः आयात कर सकते हो"
      },
      "excalidrawPlus": {
        "title": "एक्षकालीड्रॉ+",
        "button": "एक्षकालीड्रॉ+ में निर्यात करे",
        "description": "दृष्य को आपके एक्षकालीड्रॉ+ के कर्यस्थल में सम्हाले"
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "फ़ाइल से लोड करें:",
        "button": "फ़ाइल से लोड करें:",
        "description": "फ़ाइल से लोड करने पर <bold>यह आपके कार्य की जगह लेलेगा </bold><br></br>आपकी ड्रॉइंग निम्न दर्शित विकल्पो में से एक चुनके और उपयोग करके सम्हाल सकते हैं"
      },
      "shareableLink": {
        "title": "लिंक से लोड करें:",
        "button": "इस जगह प्रतिस्थापित करे",
        "description": "बाहर का चित्र लोड करने पर <bold>यह आपके कार्य की जगह लेलेगा </bold><br></br>आप आपकी ड्रॉइंग पहले निम्न दर्शित विकल्पो में से एक चुनके और उपयोग करके सम्हाल सकते हों."
      }
    }
  },
  "mermaid": {
    "title": "मर्मेड से एक्सकाली में",
    "button": "अंदर डाले",
    "description": "",
    "syntax": "मर्मेड संरचना नियम",
    "preview": "पूर्वावलोकन"
  }
}
